/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetMyReservationCreditsPathParameters } from 'api/actions/get-my-reservation-credits/get-my-reservation-credits-path-parameters';
import { GetMyReservationCreditsResponse } from 'api/actions/get-my-reservation-credits/get-my-reservation-credits-response';

type GetMyReservationCreditsQueryParameters = Record<string, any>;

/**
 * The path of the GetMyReservationCredits action.
 */
export const getMyReservationCreditsActionPath = new SweetPath<keyof GetMyReservationCreditsPathParameters>(
  '/reservations/credits',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetMyReservationCredits actions.
 */
export default function createGetMyReservationCreditsAction(axios: AxiosInstance) {
  return function getMyReservationCreditsAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetMyReservationCreditsQueryParameters } = {}) {
    const path = getMyReservationCreditsActionPath.original;

    return axios.get<GetMyReservationCreditsResponse, GetMyReservationCreditsResponse>(path, {
      params: query,
      headers,
    });
  };
}
